import { Component, computed, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SystemModulesEnum } from '@models/module/main/systemModules.enum';
import { ModuleParameter } from '@module-instance/module-parameter/module-parameter.model';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
import { CipoDialogModule, CipoFormModule } from '@shared/modules';
import { UserStore } from '@signal-store/index';

@Component({
  selector: 'app-module-parameter-dialog',
  templateUrl: './module-parameter-dialog.component.html',
  imports: [CipoDialogModule, CipoFormModule, CipoDialogHeaderComponent],
})
export class ModuleParameterDialogComponent {
  private userStore = inject(UserStore);
  public dialogRef = inject(MatDialogRef<ModuleParameterDialogComponent>);
  public moduleParameter = inject<ModuleParameter>(MAT_DIALOG_DATA);

  contractModuleName = computed(
    () =>
      this.userStore.menuItemsList()?.find(item => item.moduleId === SystemModulesEnum.Contracts)?.name || 'Contract',
  );

  valueControl = new FormControl<number>(null);

  constructor() {
    this.valueControl.setValue(this.moduleParameter.value);
  }

  onSave() {
    const value = this.valueControl.value;
    this.dialogRef.close(value);
  }
}
